// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  type FixedPricingCompany,
  type FixedPricingCompanyWireFormat,
  NewFixedPricingCompany,
} from '../FixedPricingCompany/FixedPricingCompany';
import {
  type FixedPricingProduct,
  type FixedPricingProductWireFormat,
  NewFixedPricingProduct,
} from '../FixedPricingProduct/FixedPricingProduct';
import { type NamedRef, type NamedRefWireFormat, NewNamedRef } from '../NamedRef/NamedRef';

export class FixedPricing {
  readonly id: string;
  readonly name: string;
  readonly allCompanies: boolean;
  readonly companies: FixedPricingCompany[];
  readonly products: FixedPricingProduct[];
  readonly locations: NamedRef[];
  readonly createdBy: NamedRef | null;
  readonly isArchived: boolean;
  readonly createdAt: DateTime;
  readonly updatedAt: DateTime;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.allCompanies = data.allCompanies === undefined ? false : data.allCompanies;
    this.companies = (data.companies ?? []).map((companies: any) =>
      NewFixedPricingCompany(companies),
    );
    this.products = (data.products ?? []).map((products: any) => NewFixedPricingProduct(products));
    this.locations = (data.locations ?? []).map((locations: any) => NewNamedRef(locations));
    this.createdBy =
      // eslint-disable-next-line no-nested-ternary
      (data.createdBy ?? null) === null ? null : NewNamedRef(data.createdBy);
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.createdAt = DateHelpers.ParseServerDateTime(data.createdAt);
    this.updatedAt = DateHelpers.ParseServerDateTime(data.updatedAt);
  }

  static zero(): FixedPricing {
    const zeroValues: ExcludeMethodsDeep<FixedPricing> = {
      id: NIL_UUID,
      name: '',
      allCompanies: false,
      companies: [],
      products: [],
      locations: [],
      createdBy: null,
      isArchived: false,
      createdAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
      updatedAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
    };
    return new FixedPricing(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type FixedPricingWireFormat = {
  id: string;
  name: string;
  allCompanies: boolean;
  companies: FixedPricingCompanyWireFormat[];
  products: FixedPricingProductWireFormat[];
  locations: NamedRefWireFormat[];
  createdBy: NamedRefWireFormat | null;
  isArchived: boolean;
  createdAt: string;
  updatedAt: string;
};

type NewFixedPricingProps = PartialDeep<FixedPricing, { recurseIntoArrays: true }>;
export const NewFixedPricing: (props: NewFixedPricingProps) => FixedPricing = (props) =>
  new FixedPricing(props);

type NewFixedPricingFromWireFormatProps = PartialDeep<
  FixedPricingWireFormat,
  { recurseIntoArrays: true }
>;
export const NewFixedPricingFromWireFormat: (
  props: NewFixedPricingFromWireFormatProps,
) => FixedPricing = (props) => new FixedPricing(props);
